<template>
  <dl class="row px-3 px-sm-5 pt-3 mb-0">
    <dt class="no-colon d-print-none w-xs-100">Aksiyon Seçiniz</dt>
    <dd class="single d-print-none w-xs-100 pl-1 pl-sm-0">
      <div class="form-group">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="idea-action"
            id="cbx-submit"
            data-target="#tab-form-approve"
            value="approve"
            v-model="evaluate"
          />
          <label class="form-check-label" for="cbx-submit">Onayla</label>
        </div>
        <div v-if="evaluate == 'approve'" id="tab-form-approve" style="">
          <form
            action="/Admin/Update/c5dd0e00-a1d9-eb11-bacb-000d3addce7f?updateType=1&amp;status=Distributer"
            id="update-form"
            method="post"
          >
            <div class="row pl-5 mb-2 modal-bar">Fikir Değerlendirme</div>
            <div>
              <dl>
                <div
                  v-for="category in doinPointStructureList"
                  :key="category.Id"
                  :value="category.Id"
                >
                  <label style="width: 200px"
                    ><strong>{{ category.Name }}</strong> <i v-if="category.Description" class="icon-question category-info" :title="category.Description"></i></label
                  >
                  <div
                    style="width: 100%"
                    class="form-check form-check-inline"
                    v-for="subCategory in category.SubCategories"
                    :key="subCategory.Id"
                    :value="subCategory.Id"
                  >
                    <div
                      style="width: 300px"
                      v-if="category.SubCategories.length === 2"
                      class="form-check form-check-inline"
                    >
                      <input
                        type="radio"
                        :id="'subcategory_' + subCategory.Id"
                        data-target="#tab-form-approve"
                        :value="'subcategory_' + subCategory.Id"
                        class="form-check-input"
                        :name="'category_' + category.Id"
                        :checked="
                          checkSelectedSubCategory(category.Id, subCategory.Id)
                        "
                        @change="
                          selectedCategories(category.Id, subCategory.Id)
                        "
                      />
                      <label
                        :for="'subcategory_' + subCategory.Id"
                        class="form-check-label"
                        >{{ subCategory.Name }}</label
                      >
                    </div>

                    <div
                      style="width: 300px"
                      v-if="category.SubCategories.length > 2"
                      class="form-check form-check-inline"
                    >
                      <input
                        type="checkbox"
                        :id="'subcategory_' + subCategory.Id"
                        data-target="#tab-form-approve"
                        :value="subCategory.Id"
                        class="form-check-input"
                        :name="'category_' + category.Id"
                        v-model="selectedCheckboxes"
                        @change="checkboxChangeHandler(subCategory.Id)"
                      />
                      <label
                        :for="'subcategory_' + subCategory.Id"
                        class="form-check-label"
                        >{{ subCategory.Name }}</label
                      >
                    </div>
                    <div
                      v-if="selectedCheckboxes.find((x) => x == subCategory.Id)"
                      style="display: inline-flex"
                    >
                      <div
                        v-for="childCategory in subCategory.ChildCategories"
                        :key="childCategory.Id"
                        :value="childCategory.Id"
                      >
                        <div
                          style="
                            display: inline-flex;
                            align-items: center;
                            padding-left: 3px;
                          "
                        >
                          <input
                            type="radio"
                            :id="'childCategory_' + childCategory.Id"
                            data-target="#tab-form-approve"
                            :value="'childCategory_' + childCategory.Id"
                            class="form-check-input"
                            :name="'subcategory_' + subCategory.Id"
                            :checked="
                              checkSelectedChildCategory(
                                category.Id,
                                subCategory.Id,
                                childCategory.Id
                              ) &&
                              selectedCheckboxes.find(
                                (x) => x == subCategory.Id
                              )
                            "
                            v-show="selectedCheckboxes"
                            @change="
                              selectedCategories(
                                category.Id,
                                subCategory.Id,
                                childCategory.Id
                              )
                            "
                          />
                          <label
                            :for="'childCategory_' + childCategory.Id"
                            class="form-check-label"
                            >{{ childCategory.Name }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group invalid-feedback"
                    :style="[
                      requiredField.includes('category_' + category.Id)
                        ? { display: 'block' }
                        : '',
                    ]"
                  >
                    Bu alan boş geçilemez!
                  </div>
                </div>
              </dl>
            </div>
            <div class="pl-5 mb-2">
              <strong>Fikrin Coin Değeri: {{ suggestionPoints }}</strong>
            </div>
            <div class="insider-form-button pb-2 pt-3">
              <button
                type="button"
                class="btn-innovation-radius bg-orange Roboto-Bold py-2 px-4 mr-3"
                data-dismiss="modal"
                aria-label="Close"
                @click="removeValue"
              >
                VAZGEÇ
              </button>
              <button
                :disabled="isBtnDisabled"
                type="button"
                id="btnSendUpdate"
                @click="sendUpdate(false)"
                class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
              >
                GÖNDER
              </button>
            </div>
          </form>
        </div>
      </div>
    </dd>
  </dl>
</template>

<script>
import { mapGetters } from "vuex";

import { suggestionService } from "../../../services";
export default {
  name: "CoinAdminReview",
  data() {
    return {
      requiredField: [],
      isBtnDisabled: false,
      evaluate: "approve",
      subDoinCategoryIds: [],
      isDoinUpdated: false,
      doinPointStructureList: [],
      selectedSubCategory: null,
      selectedCheckboxes: [], // Seçilen alt kategorileri saklamak için dizi
      maxSelections: 2, // Maksimum seçim sayısı
      totalPoints: 0, //toplam puan
      selectedSubCategories: [],
      suggestionPoints: 0,
    };
  },
  props: {
    detailData: {
      type: Object,
    },
    selectedDoinList: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },
  async created() {
    this.getSuggestionPoints();
    this.getDoinPointStructureList();
    this.subDoinCategoryIds = this.detailData.SubDoinCategoryIds ?? [];
    this.selectedDoinList.forEach((value) => {
      if (value.ChildCategoryId) {
        this.selectedCheckboxes.push(value.SubCategoryId);
      }
      this.selectedSubCategories.push({
        mainCategoryId: value.MainCategoryId,
        subCategoryId: value.SubCategoryId,
        childCategoryId: value.ChildCategoryId,
      });
    });
  },
  methods: {
    removeValue() {
      this.$emit("on-remove-value");
    },
    checkDoinCategoryValidations() {
      let isRequired = true;
      this.doinPointStructureList.forEach((category) => {
        if (
          this.selectedSubCategories.length == 0 ||
          !this.selectedSubCategories.find(
            (x) => x.mainCategoryId == category.Id
          )
        ) {
          isRequired = false;
        }
      });
      this.selectedCheckboxes.forEach((item) => {
        if (!this.selectedSubCategories.find((x) => x.subCategoryId == item)) {
          isRequired = false;
        }
      });
      return isRequired;
    },
    async sendUpdate() {
      this.requiredField = [];
      if (this.checkDoinCategoryValidations()) {
        this.isBtnDisabled = true;
        await this.$store.dispatch("loading/setIsLoading", true);
        this.$emit("send-update", {
          doinCategories: this.selectedSubCategories,
          callback: async () => {
            this.isBtnDisabled = false;
            await this.$store.dispatch("loading/setIsLoading", false);
          },
        });
      } else {
        this.doinPointStructureList.forEach((category) => {
          if (
            this.selectedSubCategories.length == 0 ||
            !this.selectedSubCategories.find(
              (x) => x.mainCategoryId == category.Id
            )
          ) {
            this.requiredField.push("category_" + category.Id);
          }
        });
        this.selectedCheckboxes.forEach((item) => {
          if (
            !this.selectedSubCategories.find((x) => x.subCategoryId == item)
          ) {
            this.doinPointStructureList.forEach((c) => {
              if (c.SubCategories.find((s) => s.Id == item)) {
                this.requiredField.push("category_" + c.Id);
              }
            });
          }
        });
      }
    },
    async getDoinPointStructureList() {
      try {
        const res = await suggestionService.fetchGetDoinPointStructureList();
        this.doinPointStructureList = res.Data?.filter(
          (x) =>
            !(
              (x.StartDate &&
                new Date(x.StartDate) >
                  new Date(this.detailData.SuggestionDate)) ||
              (x.EndDate &&
                new Date(x.EndDate) < new Date(this.detailData.SuggestionDate))
            )
        );
      } catch (error) {
        //console.log(error);
      }
    },
    checkboxChangeHandler(subCategoryId) {
      if (this.selectedCheckboxes.length > this.maxSelections) {
        let uncheckedSubCategoryId = this.selectedCheckboxes.shift(); //ilk seçileni kaldırabilirsiniz
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.subCategoryId !== uncheckedSubCategoryId
        );
      }
      this.selectedSubCategories = this.selectedSubCategories.filter(
        (e) => e.subCategoryId !== subCategoryId
      );
    },
    selectedCategories(mainCategoryId, subCategoryId, childCategoryId) {
      let entity = {
        mainCategoryId: mainCategoryId,
        subCategoryId: subCategoryId,
        childCategoryId: childCategoryId,
      };
      if (
        this.selectedSubCategories.find(
          (e) => e.mainCategoryId === mainCategoryId
        ) &&
        !childCategoryId
      ) {
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.mainCategoryId !== mainCategoryId
        );
      } else if (
        this.selectedSubCategories.find(
          (e) => e.mainCategoryId === mainCategoryId
        ) &&
        childCategoryId
      ) {
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.subCategoryId !== subCategoryId
        );
      }
      this.selectedSubCategories.push(entity);
    },
    checkSelectedSubCategory(categoryId, subCategoryId) {
      return this.selectedSubCategories?.find(
        (e) =>
          e.mainCategoryId === categoryId && e.subCategoryId === subCategoryId
      );
    },
    checkSelectedChildCategory(categoryId, subCategoryId, childCategoryId) {
      return this.selectedSubCategories?.find(
        (e) =>
          e.mainCategoryId === categoryId &&
          e.subCategoryId === subCategoryId &&
          e.childCategoryId === childCategoryId
      );
    },
    async getSuggestionPoints() {
      try {
        const res = await suggestionService.fetchGetSuggestionDynamicPoints(this.detailData.CreatedCustomerId,this.detailData.SuggestionNumber);
        this.suggestionPoints = res || 0;
      } catch (error) {
        //console.log(error);
      }
    },
  },
};
</script>